import { call, put, select, cancelled } from 'redux-saga/effects';

import { withApiErrorHandling } from 'utils/redux/sagaHelper';
import { statsService } from 'utils/api';

import session from 'containers/App/session';

import { createActions, createReducer, createSagaWatcher, createSelectors } from '../generators';

const KEY = 'pickUp';
const PARAMETERS = ['propertyId', 'start', 'end', 'lySpitStart', 'lySpitEnd', 'y2SpitStart', 'y2SpitEnd'];
const actions = createActions(KEY, PARAMETERS);
const { fetchCancelled, fetchStarted, fetchSucceeded, fetchFailed } = actions;

function* fetchPickUpSaga(action) {
    try {
        const { params } = action;
        const { propertyId, start, end, lySpitStart, lySpitEnd, y2SpitStart, y2SpitEnd } = params;

        yield put(fetchStarted(params));
        const token = yield select(session.selectors.selectUserToken);
        const { response, error } = yield call(withApiErrorHandling, statsService({ token, propertyId }).getPickUp, {
            start,
            end,
            ly_start: lySpitStart,
            ly_end: lySpitEnd,
            y2_start: y2SpitStart,
            y2_end: y2SpitEnd,
        });
        if (response) {
            yield put(fetchSucceeded(response.data));
        } else {
            yield put(fetchFailed(error));
        }
    } catch (error) {
        yield put(fetchFailed(error));
    } finally {
        if (yield cancelled()) yield put(fetchCancelled());
    }
}

export default {
    KEY,
    actions,
    reducer: createReducer(KEY),
    saga: createSagaWatcher(KEY, fetchPickUpSaga),
    selectors: createSelectors(KEY),
};

export { fetchPickUpSaga };
